import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../doorstepServices/DoorstepServices.css";
import { ITransactions } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Select from "react-select";
import { SingleValue, ActionMeta } from "react-select"
import eye from "../../../assets/img/icons/eye-solid.svg"
import moment from "moment";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import Paginator from "src/components/layout/Paginator";
import { useBackContext } from "src/hooks/context/BackContext";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import ExportDocs from "src/components/layout/ExportDocs";
import { Link } from "react-router-dom";
import LoadingGif from "src/components/layout/Loader";


export const getAllTransactions = async (
   token: string,
   order_type: string,
   customer_type?: string,
   customer_id?: string,

   pageNumber?: number,
   searchValue?: string,
   pageSize?: number,
   startDate?: string,
   endDate?: string,

) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/transactions`, {
      headers: {
         "x-access-token": token
      },
      params: {
         order_type,
         page: pageNumber,
         search_value: searchValue,
         pageSize,
         start_date: startDate,
         end_date: endDate,
         customer_type,
         customer_id
      }

   })
};

const TransactionDetails = () => {
   const { setIsBackClicked } = useBackContext();
   const { isBackClicked } = useBackContext();
   const [transactions, setTransactions] = useState<ITransactions[]>([]);
   const [selectedType, setSelectedType] = useState("doorstep");
   const Token = Cookies.get('token');
   const [selectedTransaction, setSelectedTransaction] = useState<ITransactions | null>(null);
   const [searchVal, setSearchVal] = useState("");
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const [startDate, setStartDate] = useState<Date | undefined>(undefined);
   const [endDate, setEndDate] = useState<Date | undefined>(undefined);
   const [hideAllFilters, setHideAllFilters] = useState(false);
   const startingDate = startDate ? startDate.toISOString() : undefined;
   const endingDate = endDate ? endDate.toISOString() : undefined;
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading?.value);

   useEffect(() => {
      setPageNo(1)
   }, [selectedType])

   useEffect(() => {
      dispatch(startLoading());
      if (Token) {

         getAllTransactions(Token, selectedType, "", "", pageNo, searchVal, pageSize, startingDate, endingDate).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {
               // console.log(res?.data)
               setTransactions(res?.data?.data?.data);
               setTotalPages(res?.data?.data?.totalPages);
            }
         })
            .catch((err: any) => {
               console.log(err)
            }).finally(() => {
               dispatch(stopLoading());
            })
      }
   }, [Token, selectedType, pageNo, searchVal, pageSize, startingDate, endingDate])


   const handleShow = (id: string) => {
      if (!id) return;
      const getSelectedDoc = transactions.find((transaction: ITransactions) => transaction?._id === id);
      if (getSelectedDoc !== undefined) {
         setSelectedTransaction(getSelectedDoc);
      };
      // setModalShow(true);
      setHideAllFilters(true)
      setIsBackClicked(false)

   }

   //  this below code is for Subscription Category name 
   const handleDropdownChange = (
      newValue: SingleValue<{ label: string | undefined; value: string | undefined }>,
      actionMeta: ActionMeta<{ label: string | undefined; value: string | undefined }>
   ) => {
      setSelectedType(newValue?.value?.toLocaleLowerCase() || '');

      // setSelectedTransaction({ ...selectedTransaction as ITransactions, type: newValue?.value?.toLocaleLowerCase() || "" });
      // console.log(newValue?.value);
   };

   const transactionOptions = ["withdraw", "membership", "subscription", "doorstep", "job"];
   const isMembershipOrSubscription = ["membership", "subscription"].includes(selectedType);
   // const isDoorstepOrRequirement = ["doorstep", "requirement"].includes(selectedType);

   const membershipExpiry = moment(selectedTransaction?.membershipAndSubscriptionsDetails?.membership_validity).format('DD-MM-YYYY hh:mm A')
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   useEffect(() => {
      if (isBackClicked) {
         setHideAllFilters(!isBackClicked)
      }
   }, [isBackClicked]);

   const handleInvoiceClick = async (id: string, order_type: string) => {
      if (!id) return;
      dispatch(startLoading());
      try {
         const res = await axios.get(`${AppConfig.DEV_SERVER}/invoice/${id}`, {
            headers: {
               "x-access-token": Token,
            },
            params: {
               type: order_type,
            },
         });
         // console.log(res)
         if (res?.data?.status_code === 200) {
            dispatch(stopLoading());
            const pdfUrl = res?.data?.data?.file;
            // setPdf(pdfUrl);
            window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
         } else {
            dispatch(stopLoading());
            Swal.fire({
               icon: "error",
               title: "Something Went Wrong...",
               text: `${res?.data?.msg}`,
            });
         }
      } catch (error) {
         dispatch(stopLoading());
         Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to fetch the invoice.",
         });
      }
   };

   const doc = new jsPDF();
   doc.text("Transactions Report", 14, 10);
   const formattedData = transactions.map((item) => {
      return {
         unique_id: item.unique_id,
         order_id: item?.order_id,
         invoice_id: isMembershipOrSubscription ? item?.membershipAndSubscriptionsDetails?.unique_id : (item?.doorstepOrderDetails?.unique_id ?? item?.jobDetails?.unique_id),
         order_type: item.order_type,
         service_count: item.doorstepOrderDetails?.service_count ?? 0,
         order_name: item.order_name,
         name:
            selectedType === "membership" || selectedType === "subscription"
               ? item.workerDetails?.name
               : item.userDetails?.name,
         payment_amount: item.payment_amount,
         date: new Date(item.createdAt).toLocaleDateString(),
         yows_comm_inc_gst: isMembershipOrSubscription ? item?.membershipAndSubscriptionsDetails?.yowsComm : item?.doorstepOrderDetails?.billing_details?.yows_comm_inc_gst?.toFixed(2),
         yows_comm_exc_gst: item?.doorstepOrderDetails?.billing_details?.yows_comm_exc_gst?.toFixed(2),
         worker_comm: item?.doorstepOrderDetails?.billing_details?.worker_comm?.toFixed(2),
         gst_on_worker_comm: item?.doorstepOrderDetails?.billing_details?.gst_on_worker_comm?.toFixed(2),
         gst_on_yows_comm: item?.doorstepOrderDetails?.billing_details?.gst_on_yows_comm?.toFixed(2),
         tcs_amt: item?.doorstepOrderDetails?.billing_details?.tcs_amt?.toFixed(2),

      };
   });

   const headers = [
      { label: "Transaction Id", key: "unique_id" },
      { label: "Order Id", key: "order_id" },
      { label: "Invoice Id", key: "invoice_id" },
      { label: "Order Type", key: "order_type" },
      {
         label: selectedType === "doorstep" ? "Service Count" : (selectedType === "membership" || selectedType === "subscription") ? "Worker Name" : "User Name",
         key: selectedType === "doorstep" ? "service_count" : "name",
      },
      { label: "Order Name", key: "order_name" },
      {
         label: selectedType === "membership" || selectedType === "subscription" ? "Worker Name" : "Customer Name",
         key: "name",
      },
      { label: "Amount Paid", key: "payment_amount" },
      { label: "Date", key: "date" },
      { label: "Yows Commision", key: "yows_comm_inc_gst" },
      { label: "Yows Commision Without GST", key: "yows_comm_exc_gst" },
      { label: "GST on Yows Commision", key: "gst_on_yows_comm" },
      { label: "Total Paid To Worker", key: "worker_comm" },
      { label: "GST in Worker Amount", key: "gst_on_worker_comm" },
      { label: "TCS if Paid", key: "tcs_amt" },
   ];

   const exportPDF = () => {
      const doc = new jsPDF();

      // headers and data
      const tableColumns = [
         'Transaction Id', 'Order Id', "Invoice Id", 'Order Type',
         `${selectedType === "doorstep" ? "Service Count" : ""}`,
         'Order Name', 'Name', 'Amount Paid', 'Date'
      ];
      const tableData = formattedData.map(item => [
         item.unique_id || '',  // Replace undefined with empty string if value is missing
         item.invoice_id || '',  // Replace undefined with empty string if value is missing
         item.order_id || '',    // Same here
         item.order_type || '',  // Same here
         item.service_count || "", // Ensure it's a number (default to 0 if undefined)
         item.order_name || '',  // Same here
         item.name || '',        // Same here
         item.payment_amount || 0, // Same here (number)
         item.date || ''        // Same here (could be empty string if date is missing)
      ]);

      // Use autoTable with the doc object
      autoTable(doc, {
         head: [tableColumns],
         body: tableData,
      });

      // Save the generated PDF
      doc.save('transactions.pdf');
   };
   const handlePageSizeChange = (e: any) => {
      setPageSize(e?.target?.value)
   }

   return (
      <MainLayout

         showAllFilters={hideAllFilters}
         searchValue={searchVal}
         clearValChange={clearSearchValue}
         onChange={(e) => setSearchVal(e.target.value)}
         startDate={startDate}
         endDate={endDate}
         startDateOnChange={e => setStartDate(e)}
         endDateOnChange={e => setEndDate(e)}
      >

         <div className="mt-3 mb-3">
            {
               loading ?
                  <div>
                     <LoadingGif />
                  </div>
                  : ""
            }
            <div className="card category-main me-2 p-md-4" >


               <div >
                  <div className="d-flex justify-content-end gap-3 mb-3 ">
                     <div className="d-flex gap-2">
                        <span className="d-flex align-items-center pagesize-text">
                           PageSize
                        </span>

                        <select
                           className="form-select"
                           style={{ backgroundPosition: "right 5px center", width: "60px" }}
                           aria-label="Default select example"
                           value={pageSize} // Bind the value to the state
                           onChange={handlePageSizeChange} // Handle the change
                        >
                           <option value={20}>20</option>
                           <option value={50}>50</option>
                           <option value={100}>100</option>
                           <option value={200}>200</option>
                        </select>
                     </div>
                     <div>
                        <ExportDocs headers={headers} formattedData={formattedData} clickHandler={exportPDF} />
                     </div>
                     <div className="d-flex justify-content-end align-items-center w-10">
                        <Select
                           name="transaction"
                           className="type-selecter w-100"
                           value={{ label: formatCategory(selectedType), value: formatCategory(selectedType) }}
                           onChange={handleDropdownChange}
                           options={transactionOptions?.map((value) => ({ label: formatCategory(value), value: formatCategory(value) }))}
                           required
                        />
                     </div>

                  </div>


                  {/* </div> */}

                  <div className="table-extra-responsive">
                     <table className="table table-striped card-body">
                        <thead>
                           <tr className="category-tr">
                              <th scope="col" className="text-start ps-4">Sr.No.</th>
                              <th scope="col" className="text-start ps-4">Taansaction Id</th>
                              <th scope="col" className="text-start ps-4">Order Id</th>
                              <th scope="col" className="text-start ps-4">Order Type</th>

                              {selectedType !== "membership" ?
                                 <th scope="col" className="text-start ps-4">Order Name</th>
                                 : ""
                              }
                              {selectedType === "doorstep" && (
                                 <>

                                    <th scope="col" className="text-start ps-4">Order Status</th>
                                    <th scope="col" className="text-start ps-4"> Yows Commission</th>

                                 </>
                              )}


                              <th scope="col" className="text-start ps-4">
                                 {isMembershipOrSubscription || selectedType === "withdraw" ? "Worker Name" : "Customer Name"}
                              </th>
                              <th scope="col" className="text-start ps-4">Amount Paid</th>
                              {
                                 isMembershipOrSubscription ?
                                    <>
                                       <th scope="col" className="text-start ps-4">Used Referral</th>
                                       <th scope="col" className="text-start ps-4">Yows Comm.</th>
                                    </>
                                    : ''
                              }
                              <th scope="col" className="text-start ps-4">Transaction Status</th>
                              <th scope="col" className="text-start ps-4">Date</th>
                              <th scope="col" className="cat_btns">Action</th>
                           </tr>
                        </thead>
                        <tbody>

                           {transactions && transactions?.map((data: ITransactions, i) => {
                              const joinDate = formatDiffrentDate(data?.createdAt);
                              const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                              console.log("unique_id: ", data?.membershipAndSubscriptionsDetails?.unique_id);
                              const orderId = isMembershipOrSubscription ? data?.membershipAndSubscriptionsDetails?.unique_id : selectedType === "withdraw" ? (data?.withdrawalDetails?.unique_id) : (data?.doorstepOrderDetails?.unique_id ?? data?.jobDetails?.unique_id);
                              return (
                                 <tr key={data?._id}>

                                    <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                    <td className="text-start ps-4 pt-3">{data?.unique_id}</td>
                                    <td className="text-start ps-4 pt-3">
                                       {orderId}
                                    </td>
                                    <td className="text-start ps-4 pt-3">{formatCategory(data?.order_type as string)}</td>


                                    {selectedType === "doorstep" && (
                                       <>
                                          <td className="text-start ps-4 pt-3">{data?.order_name}</td>
                                          <td className="text-start ps-4 pt-3">{formatCategory(data?.doorstepOrderDetails?.status as string)}</td>
                                          <td className="text-start ps-4 pt-3">{data?.doorstepOrderDetails?.billing_details?.yows_comm_inc_gst}</td>
                                       </>
                                    )}
                                    {selectedType !== "doorstep" && selectedType !== "membership" && (
                                       <td className="text-start ps-4 pt-3">{data?.order_name}</td>
                                    )}

                                    <td className="text-start ps-4 pt-3">
                                       {isMembershipOrSubscription || (selectedType === "withdraw") ? data?.workerDetails?.name : data?.userDetails?.name}
                                    </td>
                                    <td className="text-start ps-4 pt-3">&#8377; {data?.payment_amount?.toFixed(2)}</td>
                                    {
                                       isMembershipOrSubscription ?
                                          <>
                                             <td className="text-start ps-4 pt-3">{data?.membershipAndSubscriptionsDetails?.is_referralCode_used ? "Yes" : "No"}</td>
                                             <td className="text-start ps-4 pt-3">&#8377; {data?.membershipAndSubscriptionsDetails?.yowsComm}</td>
                                          </>
                                          : ""
                                    }
                                    <td className="text-start ps-4 pt-3">
                                       <span className={`${data?.status ? "text-success" : "text-danger"}`}>
                                          {data?.status ? "Successfull" : "Failed"}
                                       </span>

                                    </td>
                                    <td className="text-start ps-4 pt-3" width={"160px"}>{joinDate?.formattedDate}, <br />{joinDate?.formattedHours} </td>

                                    <td className="align-content-center">
                                       <div className="d-flex justify-content-center gap-3">
                                          <Link to={`/transactions/${data?._id}`}>

                                             <button className="btn btn-sm delete_btn" onClick={() => handleShow(data?._id)}>
                                                <img src={eye} alt="View" />
                                             </button>
                                          </Link>
                                       </div>
                                    </td>
                                 </tr>
                              );
                           })}


                        </tbody>
                     </table>
                     <Paginator
                        totalPages={totalPages}
                        pageNo={pageNo}
                        onPageChange={(e, no) => setPageNo(no)}
                        alignment="right"
                     />

                  </div>



               </div>




            </div>

         </div>

      </MainLayout>
   )

};



export default TransactionDetails;